import React, { useState, useEffect } from 'react'
import { useNavigate } from "react-router-dom";
import Style from './Style.module.css'
import Header from '../../../Components/AdminComponents/Header/Header'
import Sidebar from '../../../Components/AdminComponents/Sidebar/Sidebar'
import DataTable from '../../../Components/AdminComponents/DataTable/DataTable'
import adminInstance from '../../../instance/AdminInstance';
import Widgets from '../../../Components/AdminComponents/Widgets/Widgets';

const PremiumUserList = () => {
  const [premiumUsers, setPremiumUsers] = useState([]);
  const [totalMonthlyRevenue, setTotalMonthlyRevenue] = useState(0);
  const navigate = useNavigate();

  const columns = [
    {
      name: 'ID',
      selector: (row) => row._id,
      sortable: true,
    },
    {
      name: 'Full Name',
      selector: (row) => `${row.fullname || ''} ${row.surname || ''}`,
      sortable: true,
    },
    {
      name: 'Price',
      selector: (row) => row.price,
      sortable: true,
    },
    {
      name: 'Options',
      cell: (row) => (
        <div className={Style.optionsContainer}>
          <button className={Style.viewButton} onClick={() => navigate(`/admin/products/singles/${row._id}`)}>View</button>
          <button className={Style.deleteButton} onClick={() => handleDelete(row._id)}>Block</button>
        </div>
      ),
      width: '160px'
    },
  ];

  const loadPremiumUsers = () => {
    adminInstance
      .get("/api/super_admin/user_control/get_allsubprofile")
      .then((response) => {
        setPremiumUsers(response.data.users);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  useEffect(() => {
    loadPremiumUsers();
  }, []);

  useEffect(() => {
    const total = premiumUsers.reduce((sum, user) => {
      const monthly = parseFloat(user.subscription?.monthly_pricing || 0);
      return sum + monthly;
    }, 0);

    setTotalMonthlyRevenue(total);
  }, [premiumUsers]);

  const handleDelete = (itemId) => {
    adminInstance
      .delete(`/api/super_admin/product_control/delete_product/${itemId}`)
      .then(() => loadPremiumUsers())
      .catch((err) => console.error(err));
  };

  return (
    <div className={Style.list}>
      <Sidebar />
      <div className={Style.listContainer}>
        <Header />
        <div className={Style.widgets}>
          <Widgets type="premiumusercount" userCount={premiumUsers.length} />
          <Widgets type="subscriptionrevenue" subscriptionrevenue={totalMonthlyRevenue} />
        </div>
        <DataTable Row={premiumUsers} Columns={columns} ActionColumn="" Title="Premium Users" Path="PremiumUsers" />
      </div>
    </div>
  );
};

export default PremiumUserList;
